import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const PartnerSidebar = () => {
  const { t } = useTranslation();

  const page = window.location.pathname;

  const { userData } = useSelector((state) => state.user);

  if (!userData) return;

  return (
    <div className="col-xl-3 col-lg-4" id="hamburger-menue">
      <div className="p-3  p-md-4 bg2 br20 manu_box">
        <ul className="dashboard_manu">
          <li>
            <Link
              to="/dashboard"
              className={page === "/dashboard" ? "active" : ""}
            >
              <i class="bi bi-arrow-left"></i>
              {t("Go Back")}
            </Link>
          </li>
          <li>
            <Link
              to="/partner-dashboard"
              className={page === "/partner-dashboard" ? "active" : ""}
            >
              <i className="bi bi-person"></i>
              {t("Partner Dashboard")}
            </Link>
          </li>
          <li>
            <Link
              to="/partner-network"
              className={page === "/partner-network" ? "active" : ""}
            >
              <i className="bi bi-grid"></i> {t("Network")}
            </Link>
          </li>

          <li>
            <Link
              to="/partner-resource"
              className={page === "/partner-resource" ? "active" : ""}
            >
              <img src="/img/ds.svg" className="img-fluid" />
              {t("Resources")}
            </Link>
          </li>
          <li>
            <Link
              to="/partner-report"
              className={page === "/partner-report" ? "active" : ""}
            >
              <i className="bi bi-person-check"></i>
              {t("Reports")}
            </Link>
          </li>

          <li>
            <Link
              to="/partner-referal"
              className={page === "/partner-referal" ? "active" : ""}
            >
              <i className="bi bi-headset"></i>
              {t("Referrals")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PartnerSidebar;
